<template>
    <div class="bg-white h-screen border-r-[1px]" :class="store.state.minimized ? 'w-20' : 'w-20 lg:w-80'">
        <div class="h-14 flex items-center border-b-[1px]">
            <div class="flex px-6 gap-2 items-center cursor-pointer w-full" @click="router.push({ path: '/' })">
                <div>
                    <img src="@/assets/icon.png" class="h-6 w-7 bg">
                </div>
                <div v-if="!store.state.minimized" class="font-bold lg:block hidden">Ngantor</div>
            </div>
        </div>
        <div class="overflow-y-auto overflow-x-hidden body-scroll px-3.5 py-6 flex flex-col gap-2">
            <div @click="router.push({ path: menu.url })" class="p-3 rounded-md cursor-pointer flex gap-4"
                :class="menu.url === route.path ? 'bg-red-500 text-white' : 'hover:bg-red-100'"
                v-for="menu in store.state.menus">
                <div>
                    <img :src="require('@/assets/icons/twotone/' + menu.icon + '.svg')"
                        :class="menu.url === route.path ? 'white-filter' : ''">
                </div>
                <div v-if="!store.state.minimized" class="lg:block hidden">{{ menu.name }}</div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
import router from '@/router';

const route = useRoute()
const store = useStore()
</script>